import { IconButton, styled } from '@mui/material';

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  top: '10px',
  right: '10px',
}));
